var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"social-hover","fill":"#44B1EC","cx":"30","cy":"30","r":"30","key":0}),React.createElement("path",{"d":"M33.6234 21.0037L31.225 21c-2.6947 0-4.4361 1.7387-4.4361 4.4298v2.0425H24.377c-.2083 0-.3771.1644-.3771.3672v2.9593c0 .2028.169.367.3771.367h2.4117v7.4672c0 .2028.1687.367.3771.367h3.1465c.2084 0 .3772-.1644.3772-.367v-7.4672h2.8197c.2084 0 .3772-.1642.3772-.367l.0011-2.9593a.3626.3626 0 0 0-.1104-.2596.3825.3825 0 0 0-.267-.1076h-2.8206v-1.7314c0-.8322.2037-1.2547 1.3177-1.2547l1.6157-.0005c.2082 0 .377-.1645.377-.367v-2.748c0-.2024-.1686-.3666-.3766-.367z","fill":"#FFF","fillRule":"nonzero","key":1})]));
}

Facebook.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60"};

module.exports = Facebook;

Facebook.default = Facebook;
